<template>
  <div class="amp-img">
    <div class="amp-img-sizer" :style="'padding-top:' + image.height / image.width * 100 + '%'"></div>
    <img class="amp-img-content" :src="image.src">
  </div>
</template>

<script>
export default {
  name: 'mimic-amp-img',
  props: ['image']
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.amp-img {
  display: block;
  width: 100%;
  position: relative;
  overflow: hidden!important;
  &-sizer {
    display: block !important;
  }
  &-content {
    display: block;
    margin: auto;
    border: none !important;
    padding: 0 !important;
    width: 0;
    max-width: 100%;
    min-width: 100%;
    height: 0;
    max-height: 100%;
    min-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mimic-amp/MimicAmpImg.vue